module.exports = __webpack_public_path__ + "media/images/sozai_sex_1-7d9e4506.png";